import React, { useMemo } from "react";
import { useWebsite } from "../../../Context/WebSiteContext";

const AboutModern = ({ config }) => {
  const { formData } = useWebsite();

  const finalConfig = useMemo(() => {
    return {
      ...config,
      ...formData,
    };
  }, [config, formData]);

  const sobre = formData.sobreNos || {};
  const backgroundColor = "#142736"; // cor escura semelhante à da imagem
  const textColor = "#f5f5f5"; // texto claro
  const titleColor = "#c8b273"; // cor do título "SOBRE"

  return (
    <section
      style={{
        position: "relative",
        padding: "4rem 0",
        backgroundColor: "#fff",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {/* Imagem */}
        <div style={{ flex: "0 0 auto", width: "100%", maxWidth: "600px" }}>
          <img
            src={
              sobre.imagem ||
              "https://images.pexels.com/photos/268362/pexels-photo-268362.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            }
            alt="Imagem Sobre"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
              borderRadius: "0",
              boxShadow: "0 4px 16px #0002",
            }}
          />
        </div>

        {/* Caixa de Texto Sobreposta */}
        <div
          style={{
            backgroundColor,
            color: textColor,
            padding: "2rem",
            maxWidth: "600px",
            marginLeft: "-80px", // sobreposição
            zIndex: 2,
            position: "relative",
            boxShadow: "0 4px 16px #0002",
          }}
        >
          <h2
            style={{
              fontWeight: 600,
              color: titleColor,
              marginBottom: "1rem",
              fontSize: "1.6rem",
              textTransform: "uppercase",
            }}
          >
            Sobre
          </h2>
          <p style={{ lineHeight: "1.6", fontSize: "1rem" }}>
            {sobre.sobre_empreendimento ||
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce eget leo non urna volutpat."}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutModern;
